import Grid from '@material-ui/core/Grid'
import React from 'react'
import { COLORS } from '../COLORS'

const Line = ({ title, children }: { title: string, children: React.ReactNode }) => {
  return (
    <>
      <Grid item sm={4} md={3} style={{ color: COLORS.BLUE, fontSize: 16, fontWeight: 800 }}>
        {title}
      </Grid>
      <Grid item sm={8} md={9} style={{ marginBottom: 5 }}>
        {children}
      </Grid>
    </>
  )
}

export default Line
